import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowShareLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowShareLeft"><Path d="M1.5 12L11.5 3.5V8.5C20 8.5 22.5 12 22.5 20.5C21 17.5 20 15.5 11.5 15.5V20.5L1.5 12Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconArrowShareLeft;
